import { render } from "./SearchDetail.vue?vue&type=template&id=404ff75f"
import script from "./SearchDetail.vue?vue&type=script&lang=js"
export * from "./SearchDetail.vue?vue&type=script&lang=js"

import "./SearchDetail.vue?vue&type=style&index=0&id=404ff75f&lang=scss"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__